export default __webpack_public_path__ + "static/media/account.31388af8.svg";